module.exports = __webpack_public_path__ + "media/images/common-d6c6acfbf89c07cfed2fc7627b92a6f3.png";